import React, { useEffect, useRef } from "react";
import cx from "classnames";
import { useWalletStore } from "@/features/wallet/stores/walletStore";

import * as styles from "./Mw3dsFrame.module.scss";

export const MW_3DS_FRAME_ID = "mw3dsFrame";

export const Mw3dsFrame = () => {
  const showIframe = useWalletStore((state) => state.isManual3ds);
  const containerRef = useRef<HTMLDivElement>(null);

  // an open Radix modal traps focus with focusin/focusout on document, pulling
  // focus out of the challenge before the user can type. capture runs first
  useEffect(() => {
    if (!showIframe) {
      return;
    }

    const allowFocus = (event: FocusEvent) => {
      const container = containerRef.current;
      const involvesFrame =
        container?.contains(event.target as Node | null) ||
        container?.contains(event.relatedTarget as Node | null);

      if (involvesFrame) {
        event.stopImmediatePropagation();
      }
    };

    document.addEventListener("focusin", allowFocus, true);
    document.addEventListener("focusout", allowFocus, true);

    return () => {
      document.removeEventListener("focusin", allowFocus, true);
      document.removeEventListener("focusout", allowFocus, true);
    };
  }, [showIframe]);

  return (
    <div
      ref={containerRef}
      className={cx(styles.mw3dsFrame, {
        [styles.visible]: showIframe,
      })}
    >
      <iframe id={MW_3DS_FRAME_ID} name={MW_3DS_FRAME_ID} />
    </div>
  );
};
